import { type ReactElement } from 'react'
import { useController, useFormContext } from 'react-hook-form'
import { Autocomplete, TextField } from '@mui/material'
import { FormControl } from '@ui/forms'

/**
 * Free-form labels as chips: anything typed becomes a tag on Enter. There is
 * no fixed vocabulary yet, so the user's own words are the only options.
 */
const TagsField = (): ReactElement => {
  const { control } = useFormContext()
  const {
    field: { value, onChange, onBlur },
    fieldState: { error },
  } = useController({ name: 'tags', control })

  const tags: string[] = value ?? []

  return (
    <FormControl label="Tags" error={error?.message}>
      <Autocomplete<string, true, false, true>
        multiple
        freeSolo
        size="small"
        options={[]}
        value={tags}
        onChange={(event, newTags) =>
          // Trimmed and de-duplicated, so "Holzbau " and "Holzbau" stay one tag.
          onChange([...new Set(newTags.map(tag => tag.trim()).filter(Boolean))])
        }
        onBlur={onBlur}
        renderInput={params => (
          <TextField
            {...params}
            placeholder={tags.length ? '' : 'Tag eingeben und Enter drücken'}
            data-cy="input-tags"
            // Tall enough for a couple of rows of chips from the start, so
            // adding tags does not resize the dialog.
            sx={{
              '& .MuiOutlinedInput-root': {
                minHeight: 85,
                alignItems: 'flex-start',
                alignContent: 'flex-start',
              },
            }}
          />
        )}
      />
    </FormControl>
  )
}

export default TagsField
